import Backbone from "backbone";

export default Backbone.Radio.channel("service");
